import { Box, VStack, Text, Button, Icon } from "@chakra-ui/react";
import { MdPersonAddAlt1 } from "react-icons/md";
import { UserX } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NoAgentFound = () => {
  const navigate = useNavigate();

  const handleMoveTocreateAgent = () => {
     navigate("/", {
      state: {
        openWorkflows: false,
        movetoaicoworker:true
      },
    });
  };
  return (
    <Box
      border="1px dashed"
      borderColor="gray.300"
      borderRadius="lg"
      p={6}
      textAlign="center"
      bg="gray.50"
    >
      <VStack spacing={3}>
        <Icon as={UserX} boxSize={10} />
        <Text fontSize="lg" fontWeight="600" color="gray.700">
          No Agents Found
        </Text>
        <Text fontSize="sm" color="gray.500">
          You don’t have any agents yet. Please create one to get started.
        </Text>
        <Button
          leftIcon={<MdPersonAddAlt1 />}
          colorScheme="blue"
          size="sm"
          borderRadius="md"
          onClick={handleMoveTocreateAgent}
        >
          Create Agent
        </Button>
      </VStack>
    </Box>
  );
};

export default NoAgentFound;
